import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px auto'
  }
};

const enhance = compose();

const button = enhance(({ classes }) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      component="span"
      className={classes.button}
    >
      画像アップロード
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
